import { render } from "./Sherryspotsuk.vue?vue&type=template&id=4fdec210&scoped=true"
import script from "./Sherryspotsuk.vue?vue&type=script&lang=js"
export * from "./Sherryspotsuk.vue?vue&type=script&lang=js"

import "./Sherryspotsuk.vue?vue&type=style&index=0&id=4fdec210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdec210"]])

export default __exports__